module.exports = __webpack_public_path__ + "img/arrow-right.62b09bdb.svg";